import { createSlice } from '@reduxjs/toolkit';

import { RootState } from '$store/rootReducer';
import {
  OffersCreateFormUpdateAction,
  OffersLoadOfferAction,
  OffersMap,
  OffersEditOfferAction,
  OffersSetLoadingStatusAction,
  OffersSetMyOffersAction,
  OffersSetOffersAction,
  OffersSetOffersInfoAction,
  OffersSetStatsAction,
  OffersState,
  OffersEditFormUpdateAction,
  EditOfferFormFillAction,
} from '$store/offers/interface';

const initialState: OffersState = {
  loadingStatus: 'loading',
  offers: [],
  myOffers: [],
  offersInfo: {},
  stats: {},
  offerLoadingStatus: 'loading',
  create: {
    description: '',
    percent: '30',
    periodDays: 180,
    type: 2,
  },
  edit: {
    offerId: 0,
    description: '',
  },
};

export const { actions, reducer } = createSlice({
  name: 'offers',
  initialState,
  reducers: {
    loadOffers(state) {
      state.loadingStatus = 'loading';
    },
    setOffers(state, action: OffersSetOffersAction) {
      state.offers = action.payload;
    },
    setMyOffers(state, action: OffersSetMyOffersAction) {
      state.myOffers = action.payload;
    },
    setOffersInfo(state, action: OffersSetOffersInfoAction) {
      const map: OffersMap = {};
      for (let o of action.payload) {
        map[o.id] = o;
      }
      state.offersInfo = {
        ...state.offersInfo,
        ...map,
      };
    },
    setOffersLoadingStatus(state, action: OffersSetLoadingStatusAction) {
      state.loadingStatus = action.payload;
    },
    setStats(state, action: OffersSetStatsAction) {
      state.stats = action.payload;
    },
    loadOffer(state, action: OffersLoadOfferAction) {
      state.offerLoadingStatus = 'loading';
    },
    setOfferLoadingStatus(state, action: OffersSetLoadingStatusAction) {
      state.offerLoadingStatus = action.payload;
    },
    createFormReset(state) {
      state.create = initialState.create;
    },
    createFormUpdate(state, action: OffersCreateFormUpdateAction) {
      state.create = {
        ...state.create,
        ...action.payload,
      };
    },
    createOffer() {},
    editOffer(_, action: OffersEditOfferAction) {},
    editOfferFormFill(state, action: EditOfferFormFillAction) {
      state.edit = {
        offerId: action.payload.id,
        description: action.payload.description,
      };
    },
    editFormUpdate(state, action: OffersEditFormUpdateAction) {
      state.edit = {
        ...state.edit,
        ...action.payload,
      };
    },
  },
});

export { reducer as offersReducer, actions as offersActions };

export const offersSelector = (state: RootState) => state.offers;
